import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: 'li[uiStepItem]',
  standalone: true,
})
export class UiStepItemDirective implements OnInit, OnChanges {
  /** DaisyUI color variant for the step */
  @Input() uiStepItemColor: 'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'error' | 'info' | 'neutral' = 'primary';

  /** Whether the step is currently active (colored) */
  @Input() uiStepItemActive = true;

  private lastAppliedVariantClass: string | null = null;

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.apply();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.apply();
  }

  private apply(): void {
    const host = this.el.nativeElement;

    // Always ensure base class exists.
    this.renderer.addClass(host, 'step');

    // Only remove the variant class we previously applied (don’t touch other `step-*` classes).
    if (this.lastAppliedVariantClass) {
      this.renderer.removeClass(host, this.lastAppliedVariantClass);
      this.lastAppliedVariantClass = null;
    }

    if (this.uiStepItemActive) {
      const variant = `step-${this.uiStepItemColor}`;
      this.renderer.addClass(host, variant);
      this.lastAppliedVariantClass = variant;
    }
  }
}
